var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 61,
    viewBox: "0 0 59 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21139 0.124257L44.1156 0.123926C44.1156 0.123926 44.5 0 45 0.500146C44.0365 1.53468 42.5327 3.14924 42.5327 3.14924H3.20339V53.9747H42.5327V3.14924C42.5327 3.14924 44.0365 1.53468 45 0.500146C45.5 1 45.558 1.50014 45.558 1.50014V55.5001C45.558 55.5001 45.4062 56.0782 45 56.5001C44.578 56.9385 44 57 44 57L1.99984 57.0001C1.99984 57.0001 0.95219 57.0494 0.499999 56.5001C0.127702 56.0479 0.178065 55.5001 0.178065 55.5001V1.14633C0.178065 1.14633 0.227154 0.786778 0.499842 0.500135C0.780935 0.204658 1.21139 0.124257 1.21139 0.124257Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.63818,
    y: 14.6555,
    width: 7.26079,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1091,
    y: 14.6555,
    width: 20.5722,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63818,
    y: 21.9163,
    width: 7.26079,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1091,
    y: 21.9163,
    width: 20.5722,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63818,
    y: 29.177,
    width: 7.26079,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1091,
    y: 29.177,
    width: 20.5722,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63818,
    y: 36.4377,
    width: 7.26079,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1091,
    y: 36.4377,
    width: 20.5722,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.63818,
    y: 43.6985,
    width: 7.26079,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 17.1091,
    y: 43.6985,
    width: 20.5722,
    height: 2.42026,
    rx: 1.21013,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4953 4.24998L57.3085 5.44389C57.3085 5.44389 57.6935 5.36257 58.1275 5.89763C57.0895 6.80291 55.4696 8.21576 55.4696 8.21576L45.4955 6.92287L44.4953 4.24998L31.2894 55.4821L50.3443 57.4651L55.4696 8.21576C55.4696 8.21576 57.0895 6.80291 58.1275 5.89763C58.5616 6.4324 58.5674 6.92287 58.5674 6.92287L53.122 59.2483C53.122 59.2483 52.9166 59.7931 52.4804 60.161C52.0273 60.5432 51.461 60.5446 51.461 60.5446L31.1121 58.427L10.7632 56.3093C9.882 56.2593 31.0969 56.4773 31.2938 55.482L44.4953 4.24998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentLibrary);
export default __webpack_public_path__ + "static/media/assessment-library.0636b2607700274f93eaf0345c3d4ef5.svg";
export { ForwardRef as ReactComponent };